<template>
  <div>
    <div>
      <div
      class="
        text-center
        border-5x
        h-200
        margin-top-3x margin-left-3x
        padding-top-6x
        bg-g12
      "
      style="width: 44%;display: inline-block;"
      @click="tiaozhuan(item.id)"
      v-for="(item, i) in type"
      v-bind:key="i"
      :style="{background:item.color_type}"
    >
      <div >
        <div class="f-40">{{ item.name }}</div>
        <div class="margin-top text-transform">{{ item.english }}</div>
      </div>
    </div>
    </div>
    <img
        class="icon-11x under2"
        :src="uploadpath + 'resource/' + Res.back"
        alt=""
        @click="routeto('/')"
      />
  </div>
</template>
<script>
import Config from "../Config";
import { PageHelper } from "../PageHelper";
import { HttpHelper } from "../HttpHelper";
import { Utils } from "../Utils";

export default {
  data() {
    return {
      Res: {},
      Inst: {},
      Member: null,
      bannerlist: [],
      productlist: [],
      problemlist: [],
      attrlist: [],
      list: [],
      show: false,
      right: "A",
      type: [],
    };
  },
  created() {
    PageHelper.Init(this);
    HttpHelper.Post("shop/type", {}).then((ret) => {
      this.type = ret;
    });
  },
  methods: {
   color(value){
    return value;
   },
   tiaozhuan(type){
    // if (this.token == "null" || this.token == "" || this.token == null) {
    //     Toast("请先登录！");
    //     this.routeto("/login");
    //   } else {
        this.routeto("/vs/"+type)
      // }
   }
  },
};
</script>
<style scoped>
 
</style>


// WEBPACK FOOTER //
// src/components/Type.vue